<div class="spinner-wrap" *ngIf="!isLoading && enableCountry">
  <cmx-loading
    [size]="'48'"
    [descriptionShow]="true"
    [label]="'views.spinner.title.plese_wait' | translate"
  ></cmx-loading>
</div>

<div class="col-md-12 unable-order" *ngIf="!isValidOrder && isLoading">
  <span class="cmx-icon-information-rounded-fill font-bright-orange cmx-icon-field" aria-hidden="true"></span>
  <div>{{ 'view.unable_order' | translate }}</div>
</div>

<!-- Template info -->
<div class="no-cmx-padding-bottom mb-sm" [ngClass]="{ 'center-order-info': !!hasBeenPlaced }">
  <template #preview></template>
</div>

<!-- Feature: Terms and conditions -->
<ng-container *ngIf="!hasBeenPlaced">
  <div *ngIf="features && features[OneClickElement.TERMS_AND_CONDITIONS] && isValidOrder" class="checkbox-align">
    <div>
      <p>
        {{ 'views.checkout.terms_conditions_one' | translate }} {{ 'views.checkout.terms_conditions_two' | translate }}
      </p>
      <a
        (click)="saveTermsAndConditionsDocument()"
        class="terms-conditions__download"
        [ngClass]="{ 'terms-conditions__download--loading': termsAndConditions.loading }"
      >
        {{ 'views.checkout.terms_conditions_download' | translate }}
      </a>
    </div>
    <div>
      <cwc-checkbox (cwcChange)="setTermsAndConditions($event.detail)" [checked]="checkByDefault" designVersion="v2"> </cwc-checkbox>
    </div>
  </div>
</ng-container>
